import { Link } from 'react-router-dom';
import ScrollReveal from '@/components/ScrollReveal';

export default function FinalCTA() {
  return (
    <section className="py-16 md:py-32 bg-secondary/30">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16">
        <ScrollReveal>
          <div className="text-center">
            <h2 className="font-display font-extrabold text-navy" style={{ fontSize: 'clamp(2rem, 5vw, 4rem)' }}>
              Ready to protect<br />your property?
            </h2>
            <p className="text-lg text-muted-foreground mt-6 max-w-xl mx-auto">
              Get an instant quote or book your service directly. It takes less than two minutes.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center mt-10">
              <Link to="/request-quote" className="px-8 py-4 bg-orange text-navy font-semibold rounded-full hover:bg-orange-dark transition-colors">
                Request Quote
              </Link>
              <Link to="/book-now" className="px-8 py-4 bg-navy text-white font-semibold rounded-full hover:bg-navy-light transition-colors">
                Book Now
              </Link>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}